import { useState } from 'react';
import InnerLayout from '../../Layout/InnerLayout';
import styles from './style/Lists.module.scss';
import { MdEditNote } from 'react-icons/md';
import { useDispatch } from 'react-redux';

import Button from '../../Utilities/Button';
import Paginate from '../../Utilities/Paginate';
import EmptyBox from '../../Utilities/EmptyBox';
import Dropdown from '../../Utilities/DropdownDynamic';

import { useEffect } from 'react';
import ModalCategory from './ModalCategory';
import { useSelector } from 'react-redux';
import Tips from '../../Utilities/Tips';
import { BsSearch } from 'react-icons/bs';
import { IoAddOutline } from 'react-icons/io5';
import { VscGlobe } from 'react-icons/vsc';
import { getListsLanguage, selectMultilingual } from '../../../store/slice/language/multilingual';
import { getIndustries, industriesDetail, selectIndustries } from '../../../store/slice/language/industries';

const PAEISettings = () => {
  const dispatch = useDispatch();
  const { lists } = useSelector(selectMultilingual);
  const { industries } = useSelector(selectIndustries);

  const [options, setOptions] = useState([]);
  const [choose, setChoose] = useState('繁體中文');
  const [fetchSearchValue, setFetchSearchValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [code, setCode] = useState({
    text: '繁體中文',
    value: 1,
    code: 'zh-TW',
  });

  const [isOpen, setIsOpen] = useState(false);
  const [detail, setDetail] = useState('');

  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    dispatch(getListsLanguage());
  }, [dispatch]);

  useEffect(() => {
    if (!isOpen) dispatch(getIndustries({ limit: limit, page: page, search: searchValue, code: code?.value }));
  }, [dispatch, limit, page, searchValue, code, isOpen]);

  useEffect(() => {
    const array = [];
    lists?.data?.forEach((item) => {
      array.push({ text: item.language, value: item.id, code: item.code });
    });
    setOptions(array);
  }, [lists]);

  const handleChangeLanguage = (value) => {
    setChoose(value?.text);
    setCode(value);
  };

  const pageChangeHandler = (e) => {
    setPage(parseInt(e.selected + 1));
  };

  const handleSearch = (e) => {
    if (e.code === 'Enter' || e.charCode === 13) {
      setSearchValue(fetchSearchValue);
      setPage(1);
    }
  };

  return (
    <InnerLayout>
      <div className={styles.dashboardOuter}>
        <div className={styles.header}>
          <div className={styles.title}>企業產業類別</div>
        </div>

        <div className={styles.tableContainer}>
          <div className={styles.title}>
            <span />
            <div className={styles.actionButton}>
              <div className={styles.searchOutline}>
                <input
                  type='text'
                  placeholder='搜尋產業項目'
                  className='searchInput'
                  onChange={(e) => setFetchSearchValue(e.target.value)}
                  value={fetchSearchValue}
                  onKeyUp={handleSearch}
                />
                <div
                  className={styles.BsSearch}
                  onClick={() => {
                    setSearchValue(fetchSearchValue);
                    setPage(1);
                  }}
                >
                  <BsSearch />
                </div>
              </div>

              <span style={{ display: 'none' }}>
                <Button type='primary' icon={<IoAddOutline fontSize={20} />} title={`新增產業類別`} onClick={() => {}} />
              </span>

              <span>
                <Dropdown
                  icon={<VscGlobe className={styles.icon} />}
                  color={'#5856d6'}
                  background={'#DFDFF7'}
                  placeholder='全部'
                  value={choose}
                  listItems={options}
                  onChange={(e) => handleChangeLanguage(e)}
                  caption={'text'}
                />
              </span>
            </div>
          </div>

          <table>
            <thead>
              <tr>
                <th>產業類別</th>
                <th>原始資料</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {industries?.rows?.length > 0 ? (
                industries?.rows?.map((data, index) => (
                  <tr key={index}>
                    <td>{data[code?.code]}</td>
                    <td>{data.industry}</td>
                    <td>
                      <div className={styles.buttonWrapper}>
                        <span>
                          <Tips detail={'查看職能慣性項目'}>
                            <Button
                              type='pure'
                              icon={<MdEditNote />}
                              onClick={() => {
                                const postObj = {
                                  id: data.id,
                                  code: code?.value,
                                };
                                dispatch(industriesDetail(postObj));
                                setDetail(data);
                                setIsOpen(true);
                              }}
                            />
                          </Tips>
                        </span>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3}>
                    <EmptyBox caption={'請先前往右上角「上傳資料」上傳ASK檔案'} type={3} height={300} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {industries?.total > 0 && (
          <Paginate
            onPageChange={pageChangeHandler}
            pageCount={page}
            limit={limit}
            totalPages={Math.ceil(industries.total / 10)}
            totalData={industries.total}
          />
        )}
      </div>

      <ModalCategory detail={detail} setDetail={setDetail} setIsOpen={setIsOpen} isOpen={isOpen} code={code} setCode={setCode} />
    </InnerLayout>
  );
};
export default PAEISettings;
